import './vendor/bootstrap';
import 'slick-carousel';
import './app/forms';
import './app/homepage';
import './app/global';


// WEBPACK FOOTER //
// ./src/js/bundle.js